<div class="card pep-card" *ngIf="group">
  <h2>Persona políticamente expuesta</h2>
  <p>Ingresa algunos datos de forma manual</p>

  <div class="insured-block">
    <div class="pep-grid" [formGroup]="group">

      <div class="pep-grid-2x4">
        <div class="pep-row pep-grid-item-2cols">
          <app-sis-radio-group
            legend="¿Ocupa o ha ocupado usted un puesto público de conformidad con la ley contra lavado de dinero?"
            [options]="yesNoOptions"
            formControlName="isPep">
          </app-sis-radio-group>
        </div>

        <div class="field" *ngIf="isPepSelected">
          <app-sis-field label="Cargo" formControlName="position"></app-sis-field>
        </div>

        <div class="field" *ngIf="isPepSelected">
          <app-sis-date-field label="Fecha de inicio" formControlName="startDate"></app-sis-date-field>
        </div>

        <div class="field" *ngIf="isPepSelected">
          <app-sis-date-field label="Fecha final" formControlName="endDate"></app-sis-date-field>
        </div>

        <div class="field" *ngIf="isPepSelected">
          <app-sis-field label="Nacionalidad" formControlName="pepNationality"></app-sis-field>
        </div>

        <div class="field" *ngIf="isPepSelected">
          <app-sis-field label="Tipo de documento" formControlName="pepDocumentType"></app-sis-field>
        </div>

        <div class="field" *ngIf="isPepSelected">
          <app-sis-field label="Número de documento" formControlName="pepDocumentNumber"></app-sis-field>
        </div>

        <div class="field" *ngIf="isPepSelected">
          <app-sis-select label="Procedencia de fondos para adquisición del bien" [options]="fundsOptions" formControlName="fundsOrigin"></app-sis-select>
        </div>
      </div>

      <div class="info-banner">
        <div class="info-banner-icon">
          <img src="assets/agricola/toast-idea.svg" alt="" aria-hidden="true">
        </div>
        <div class="info-banner-text">
          <span>Ingresa misma información antes completada, no debe variar los ingresos proyectados del cliente</span>
        </div>
      </div>

      <div class="grid-2">
        <div class="field">
          <app-sis-select label="Fuente de ingresos" [options]="fundsOptions" formControlName="incomeSource"></app-sis-select>
        </div>

        <div class="field">
          <app-sis-field label="Estimación de ingresos proyectados mensuales" formControlName="projectedIncome"></app-sis-field>
        </div>
      </div>

      <div class="pep-grid-2x4">
        <div class="pep-row pep-grid-item-2cols">
          <app-sis-radio-group
            legend="¿Ocupa o ha ocupado algún familiar puesto público de conformidad a la ley contra el lavado de dinero?"
            [options]="yesNoOptions"
            formControlName="relativePep">
          </app-sis-radio-group>
        </div>

        <div class="field" *ngIf="isRelativePepSelected">
          <app-sis-field label="Cargo" formControlName="relativePosition"></app-sis-field>
        </div>

        <div class="field" *ngIf="isRelativePepSelected">
          <app-sis-date-field label="Fecha de inicio" formControlName="relativeStartDate"></app-sis-date-field>
        </div>

        <div class="field" *ngIf="isRelativePepSelected">
          <app-sis-date-field label="Fecha final" formControlName="relativeEndDate"></app-sis-date-field>
        </div>

        <div class="field" *ngIf="isRelativePepSelected">
          <app-sis-field label="Nacionalidad" formControlName="relativeNationality"></app-sis-field>
        </div>

        <div class="field" *ngIf="isRelativePepSelected">
          <app-sis-field label="Tipo de documento" formControlName="relativeDocumentType"></app-sis-field>
        </div>

        <div class="field" *ngIf="isRelativePepSelected">
          <app-sis-field label="Número de documento" formControlName="relativeDocumentNumber"></app-sis-field>
        </div>

        <div class="field" *ngIf="isRelativePepSelected">
          <app-sis-select label="Procedencia de fondos para adquisición del bien" [options]="fundsOptions" formControlName="relativeFundsOrigin"></app-sis-select>
        </div>
      </div>

      <div class="grid-2" *ngIf="isRelativePepSelected">
        <div class="field">
          <app-sis-select label="Fuente de ingresos" [options]="fundsOptions" formControlName="relativeIncomeSource"></app-sis-select>
        </div>

        <div class="field">
          <app-sis-field label="Estimación de ingresos proyectados mensuales" formControlName="relativeProjectedIncome"></app-sis-field>
        </div>
      </div>

    </div>
  </div>

  <div class="actions dialog-actions" *ngIf="isDialog">
    <app-sis-button (pressed)="close()">Cerrar</app-sis-button>
  </div>
</div>
